import React, { useContext, useEffect, useRef, useState } from 'react';
import { Button, Col, Image, Row } from 'react-bootstrap';
import ArrowBack from 'assets/images/WithoutLogin/arrow-left.svg';
import AbsoluteLogoMobile from 'assets/images/WithoutLogin/absolute-logo-phone.svg';
import AddIcon from 'assets/images/WithoutLogin/add.svg';
import CommonModal from 'components/commom/Modal';
import SelectInput from 'components/commom/SelectInput';
import InputAdornment from '@mui/material/InputAdornment';
import { FormattedMessage, useIntl } from 'react-intl';
import { LocaleContext } from 'routes/Router';
import { useDispatch, useSelector } from 'react-redux';
import { getPracticeList } from 'store/registerPractice/registePracticeAction';
import SelectInputList from 'components/commom/SelectInputList';
import deteteIcon from 'assets/images/WithoutLogin/delete.svg';
import { registerUploadAction } from 'store/registerUpload/registerUploadAction';
import UploadIconList from 'assets/images/WithoutLogin/upload-list.svg';
import LabelWithoutInputList from 'components/commom/LabelWithoutInputList';
import { registerProfessionalPost } from 'store/registerProfessional/registerProfessionalAction';
import { deleteRegisterProfessionalCategoryData } from 'store/deleteRegisterProfessionalCategory/deleteRegisterProfessionalCategoryAction';
import LocalStorageManager from 'managers/LocalStorageManger';
import { getReviewDetail } from 'store/registerReview/registerReviewAction';
import { useNavigate } from 'react-router-dom';
import { registerContractDetail, registerFinal } from 'routes/AppUrls';
import ReusableButton from 'components/commom/Button';
import CommonToast from 'components/commom/CommonToast';

const RegisterProfessionalDetail = () => {
  const intl = useIntl();
  const brandImageFileInputRef = useRef([]);
  const { locale } = useContext(LocaleContext);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const [isProfessionalModal, setIsProfessionalModal] = useState(false);
  const [providerData, setProviderData] = useState([]);

  const registerUserReducer = useSelector(
    (state) => state?.registerUserReducer?.users?.data
  );

  const [formData, setFormData] = useState(providerData?.[0]);
  const [id, setId] = useState(providerData?.[0]?.id ?? '');
  const [subListId, setsubListId] = useState([]);
  const [subListPrev, setSubListPrev] = useState([]);
  const [subList, setsubList] = useState([]);
  const [providerValue, setProviderValue] = useState();
  const [doctoreData, setDoctorData] = useState();

  const [disabledSubPracticeIds, setDisabledSubPracticeIds] = useState([]);

  const registerReducer = useSelector(
    (state) => state?.registerProfessionalReducer?.loading
  );

  const reviewData = useSelector(
    (state) => state?.getReviewDetailReducer?.users?.data
  );

  useEffect(() => {
    getPractices();
    getPracticesData();
  }, []);

  const getPractices = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        setProviderData(res?.data);
      },
      error: true,
      handleErrorFunction: (res) => {},
    };
    dispatch(getPracticeList(external));
  };

  useEffect(() => {
    if (providerValue && providerData) {
      const data = providerData?.find(
        (item) => item?.practice_name === providerValue
      );
      setFormData(
        // providerValue === 'Aesthetician' ? providerData?.[0] : providerData?.[1]
        data
      );
      setId(
        // providerValue === 'Aesthetician'
        //   ? providerData?.[0]?.id
        //   : providerData?.[1]?.id
        data?.id
      );
    }
  }, [providerData, providerValue]);

  const getPracticesData = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        handleSuccess(res);
      },
      error: true,
      handleErrorFunction: (res) => {},
    };
    dispatch(getReviewDetail(LocalStorageManager.getItem('userId'), external));
  };

  const handleSuccess = (res) => {
    setProviderValue(res?.data?.title?.name);
    setDoctorData(res?.data);
    const doctorSubPracticeInfo =
      res?.data?.doctor_practice_info?.[0]?.doctor_sub_practice_info;

    if (doctorSubPracticeInfo) {
      setDisabledSubPracticeIds(doctorSubPracticeInfo.map((item) => item.id));
    }

    if (doctorSubPracticeInfo) {
      let arr = [...subListId];
      let arrList = [...subListPrev];
      doctorSubPracticeInfo &&
        doctorSubPracticeInfo.length > 0 &&
        doctorSubPracticeInfo.map((item, index) => {
          arr.push(item?.id);
          arrList.push({
            sub_practice_id: item?.id,
            sub_practice_name: item?.sub_practice,
            state_code_id: item?.state_code?.id,
            state_license_id: '',
            fee_per_session: item?.fee_per_session,
            doctor_practice_id: res?.data?.doctor_practice_info?.[0]?.id,
            code: item?.state_code?.name,
            state_license: item?.state_license,
          });
          setsubListId(arr);
          setSubListPrev(arrList);
          setsubList(arrList);
        });
    }
  };

  const handleOpenModal = () => {
    setIsProfessionalModal(true);
  };

  const handleCloseModal = () => {
    setIsProfessionalModal(false);
  };

  const handleSelectPractice = (value) => {
    let arr = [...subListId];
    let arrList = [...subListPrev];
    if (arr.includes(value.id)) {
      let index = arr.findIndex((item) => item === value.id);
      let indexList = arrList.findIndex((item) => item === value);
      arr.splice(index, 1);
      arrList.splice(indexList, 1);
      setsubListId(arr);
      setSubListPrev(arrList);
    } else {
      arr.push(value.id);
      arrList.push({
        sub_practice_id: value?.id,
        sub_practice_name: value?.name,
        state_code_id: '',
        state_license_id: '',
        fee_per_session: '',
        doctor_practice_id: id,
        code: '',
        state_license: '',
      });
      setsubListId(arr);
      setSubListPrev(arrList);
    }
  };

  const handleSelectList = () => {
    setsubList(subListPrev);
    setIsProfessionalModal(false);
  };

  const handleRemoveList = (sub_practice_id, index, event, isDisabled) => {
    event.stopPropagation();

    if (isDisabled) {
      const external = {
        run: true,
        handleFunction: (res) => {
          showToast(res?.message, 'success');
          //getPracticesData();
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {
          //ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      };

      let bodyData = {
        sub_practice_id: sub_practice_id,
        doctor_id: doctoreData?.id,
        request_id: doctoreData?.request_info?.request_id,
      };

      dispatch(
        deleteRegisterProfessionalCategoryData(bodyData, external, 'doctor')
      );
    }

    const newUploadImageData = [...subList];
    newUploadImageData.splice(index, 1);
    subListId.splice(index, 1);
    setsubList(newUploadImageData);
    setSubListPrev(newUploadImageData);
  };

  const handleChange = (event) => {
    setFormData(event?.target?.value);
    setsubListId([]);
    setsubList([]);
  };

  const handleStateChange = (event, name, index) => {
    const { value } = event?.target;
    const updatedDetails = [...subListPrev];
    updatedDetails[index].code = value?.code;
    updatedDetails[index].state_code_id = value?.id;
    setSubListPrev(updatedDetails);
  };

  const handleInputChange = (event, name, index) => {
    const updatedDetails = [...subListPrev];
    updatedDetails[index].fee_per_session = event?.target?.value;
    setSubListPrev(updatedDetails);
  };

  const handleBrandImageUpload = (index) => {
    brandImageFileInputRef.current[index]?.click();
  };

  const handleBrandImageFileChange = (e, index) => {
    const file = e.target.files?.[0];
    let Data = new FormData();
    Data.append('filePath', file);
    const external = {
      run: true,
      handleFunction: (res) => {
        const filePath = res?.data?.[0]?.filePath;
        const fileName = filePath ? filePath.split('/').pop() : null;

        const updatedDetails = [...subListPrev];
        updatedDetails[index].state_license = fileName;
        updatedDetails[index].state_license_id = res?.data?.[0]?.id;
        setSubListPrev(updatedDetails);

        showToast(res?.message, 'success');
      },
      error: true,
      handleErrorFunction: (res) => showToast(res?.message, 'error'),
    };
    dispatch(registerUploadAction(Data, external));
  };

  const handleProfessional = () => {
    const external = {
      run: true,
      handleFunction: (res) => {
        showToast(res?.message, 'success');
        navigate(registerContractDetail(locale));
      },
      error: true,
      handleErrorFunction: (res) => {
        showToast(res?.message, 'error');
      },
    };

    let isValid = false;

    if (reviewData?.address?.country?.id === 2) {
      isValid = subList.every((item, index) => {
        const amount = item?.fee_per_session;
        const uploadId = item?.state_license;

        return amount && uploadId;
      });
    } else {
      isValid = subList.every((item, index) => {
        const stateCode = item?.code;
        const stateCodeId = item?.state_code_id;
        const amount = item?.fee_per_session;
        const uploadId = item?.state_license;

        return stateCode && stateCodeId && amount && uploadId;
      });
    }

    if (!isValid) {
      showToast('Please ensure all fields are filled for each item.', 'error');
      return;
    }

    let body;

    if (reviewData?.address?.country?.id === 2) {
      const filteredSublist = subList.filter(
        (item) => !disabledSubPracticeIds.includes(item.sub_practice_id)
      );

      body = filteredSublist.map((obj) =>
        Object.fromEntries(
          Object.entries(obj).filter(([_, value]) => value !== '')
        )
      );
    } else {
      const filteredSublist = subList.filter(
        (item) => !disabledSubPracticeIds.includes(item.sub_practice_id)
      );

      body = filteredSublist;
    }
    dispatch(
      registerProfessionalPost(
        body,
        LocalStorageManager.getItem('userId'),
        external,
        false
      )
    );
  };

  return (
    <>
      <Row className="m-0 p-0 landing-image">
        <Row className="mb-4 pt-80 size-padding flex justify-center">
          <Col
            xs={12}
            sm={10}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className={
              subList && subList?.length > 0
                ? 'bg-gray-100 sm:bg-light-100 m-0 p-0'
                : 'professional-card bg-gray-100 sm:bg-light-100 m-0 p-0'
            }
          >
            <div class="p-16 sm:p-32">
              <div className="d-flex">
                <div className="d-flex" onClick={() => navigate(-1)}>
                  <Image
                    src={ArrowBack}
                    alt={'icon'}
                    className="cursor-pointer"
                  />
                </div>
                <div className="main-heading pl-8 family_outfit_semiBold_600">
                  Registration
                </div>
              </div>
              <Row className="m-0 p-0">
                <Col xs={12} className="m-0 p-0 d-none d-sm-flex">
                  <p className="pt-24 m-0 fs-14 family_outfit_regular_400 lh-176 fc-C56616">
                    Step 2/4
                  </p>
                </Col>
                <Col xs={12} className="m-0 p-0 d-none d-sm-flex">
                  <p className="pt-04 pb-16 m-0 fs-18 family_outfit_semiBold_600 lh-2068 fc-292D32">
                    Personal Details
                  </p>
                </Col>
                <div className=" m-0 p-0 d-flex d-sm-none justify-content-between">
                  <div>
                    <p className="pt-24 m-0 fs-14 family_outfit_regular_400 lh-176 fc-C56616">
                      Step 2/3
                    </p>
                    <p className="pt-04 m-0 fs-18 family_outfit_semiBold_600 lh-2068 fc-292D32">
                      Personal Details
                    </p>
                  </div>
                  <div className="d-flex align-items-center mt-4">
                    <Image src={AbsoluteLogoMobile} alt={'icon'} />
                  </div>
                </div>
              </Row>
              {subList && subList?.length > 0 ? (
                <div>
                  <div className="pt-16 pb-8 fs-18 family_outfit_semiBold_600 fc-864629">
                    Practice name - {formData?.practice_name}
                  </div>
                  <Row className="m-0 p-0 fs-14 lh-16 family_outfit_semiBold_600 profession-detail">
                    <Col sm={4} className="profession-heading">
                      Sub-practice name
                    </Col>
                    {reviewData?.address?.country?.id !== 2 && (
                      <Col sm={2} className="profession-heading">
                        State Code
                      </Col>
                    )}
                    <Col
                      sm={reviewData?.address?.country?.id !== 2 ? 3 : 4}
                      className="profession-heading"
                    >
                      Qualification Document
                    </Col>
                    <Col
                      sm={reviewData?.address?.country?.id !== 2 ? 2 : 3}
                      className="profession-heading"
                    >
                      Fee per session
                    </Col>
                    <Col sm={1} className="profession-heading">
                      Action
                    </Col>
                  </Row>

                  {subList && subList?.length > 0 && (
                    <div>
                      {subList.map((item, index) => {
                        const isDisabled = disabledSubPracticeIds.includes(
                          item.sub_practice_id
                        );

                        return (
                          <>
                            <Row className="m-0 p-0 fs-14 lh-176 family_outfit_regular_400 profession-detail-list">
                              <Col sm={4} className="profession-heading-detail">
                                {item?.sub_practice_name}
                              </Col>
                              {reviewData?.address?.country?.id !== 2 && (
                                <Col
                                  sm={2}
                                  className="profession-heading-detail"
                                >
                                  <SelectInputList
                                    placeholder={intl.formatMessage({
                                      id: 'State Code',
                                    })}
                                    name={'code'}
                                    value={item?.code}
                                    data={registerUserReducer}
                                    disabled={isDisabled}
                                    onChange={(e) =>
                                      handleStateChange(e, 'code', index)
                                    }
                                  />
                                </Col>
                              )}
                              <Col
                                sm={
                                  reviewData?.address?.country?.id !== 2 ? 3 : 4
                                }
                                className="profession-heading-detail"
                              >
                                <div className="d-flex pb-3">
                                  <input
                                    id={`file-upload-${index}`}
                                    ref={(el) =>
                                      (brandImageFileInputRef.current[index] =
                                        el)
                                    }
                                    type="file"
                                    accept=".png, .jpg, .jpeg, .gif, .mp4, .pdf"
                                    disabled={isDisabled}
                                    style={{ display: 'none' }}
                                    onChange={(e) =>
                                      handleBrandImageFileChange(e, index)
                                    }
                                  />
                                  <label
                                    className="cursor-pointer d-flex align-items-center"
                                    htmlFor={`file-upload-${index}`}
                                  >
                                    {item?.state_license ? (
                                      <div className="pl-8 pt-0.5 fs-14 lh-176 fc-5B88E9 family_outfit_medium_500 underline decoration-1 truncate max-w-xs">
                                        {item?.state_license
                                          ? item.state_license.split('/').pop()
                                          : ''}
                                      </div>
                                    ) : (
                                      <div className="d-flex">
                                        <div>
                                          <img
                                            src={UploadIconList}
                                            alt="Upload Icon"
                                          />
                                        </div>
                                        <div className="pl-8 pt-0.5 fs-14 lh-176 fc-C56616 family_outfit_medium_500 underline decoration-1 ...">
                                          Upload file
                                        </div>
                                      </div>
                                    )}
                                  </label>
                                </div>
                              </Col>

                              <Col
                                sm={
                                  reviewData?.address?.country?.id !== 2 ? 2 : 3
                                }
                                className="profession-heading-detail"
                              >
                                <LabelWithoutInputList
                                  placeholder="Fee per session"
                                  name="fee_per_session"
                                  type="text"
                                  value={item?.fee_per_session}
                                  onChange={(e) =>
                                    handleInputChange(
                                      e,
                                      'fee_per_session',
                                      index
                                    )
                                  }
                                  InputProps={{
                                    startAdornment: (
                                      <InputAdornment position="start">
                                        <div className="fs-18 lh-18 fc-202224 family_outfit_regular_400 pt-1">
                                          $
                                        </div>
                                      </InputAdornment>
                                    ),
                                  }}
                                  disabled={isDisabled}
                                />
                              </Col>
                              <Col
                                sm={1}
                                className="flex items-center justify-center cursor-pointer ..."
                              >
                                <div
                                  className="flex items-center	justify-center"
                                  onClick={(event) =>
                                    handleRemoveList(
                                      item.sub_practice_id,
                                      index,
                                      event,
                                      isDisabled
                                    )
                                  }
                                >
                                  <Image src={deteteIcon} alt={'icon'} />
                                </div>
                              </Col>
                            </Row>
                          </>
                        );
                      })}
                      <div className="flex pt-16">
                        <div
                          className="add-detail"
                          onClick={() => handleOpenModal()}
                        >
                          <Image src={AddIcon} alt={'icon'} />
                          <div className="fs-16 family_outfit_medium_500 lh-16 c-C56616 pl-04">
                            Add a Practice
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              ) : (
                <>
                  <Row className="m-0 p-0 fs-14 lh-16 family_outfit_semiBold_600 profession-detail d-none d-sm-flex">
                    <Col sm={3} className="profession-heading">
                      Sub-practice name
                    </Col>
                    {reviewData?.address?.country?.id !== 2 && (
                      <Col sm={2} className="profession-heading">
                        State Code
                      </Col>
                    )}
                    <Col sm={2} className="profession-heading">
                      Qualification Document
                    </Col>
                    <Col sm={2}>Fee per session</Col>
                  </Row>
                  <Row className="m-0 p-0">
                    <Col sm={12}>
                      <div className="fs-16 family_outfit_medium_500 lh-201 fc-7F7F7F pt-48 sm:pt-24 flex justify-center">
                        Select a practice to get started
                      </div>

                      <div className="flex justify-center	pt-24">
                        <div
                          className="add-detail"
                          onClick={() => handleOpenModal()}
                        >
                          <Image src={AddIcon} alt={'icon'} />
                          <div className="fs-16 family_outfit_medium_500 lh-16 c-C56616 pl-04">
                            Add a Practice
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </>
              )}
              {subList?.length > 0 ? (
                <>
                  <Row className="flex justify-between pt-48 sm:pt-16">
                    <Col xs={12} sm={8} className="flex items-center">
                      <div className="fs-14 family_outfit_regular_400 lh-196 fc-A4AAB2">
                        Supported formats: JPEG, PNG, GIF, MP4, PDF
                      </div>
                    </Col>
                    <Col xs={12} sm={4} className="">
                      <Row>
                        <Col sm={6}>
                          <ReusableButton
                            fullWidth={true}
                            variant="outlined"
                            color="#3C3C3C"
                            fontSize="16px"
                            fontWeight="500"
                            padding="14px 55px"
                            height="44px"
                            bgColor="transparent"
                            brColor="#EFE3D7"
                            fontFamily="outfit_medium"
                          >
                            <FormattedMessage id="Cancel" />
                          </ReusableButton>
                        </Col>
                        <Col sm={6}>
                          <ReusableButton
                            fullWidth={true}
                            variant="outlined"
                            color="#F5F5F5"
                            fontSize="18px"
                            fontWeight="600"
                            padding="12px 50px"
                            height="44px"
                            bgColor="#375241"
                            brColor="#375241  "
                            fontFamily="outfit_semiBold"
                            onClick={() => {
                              !registerReducer && handleProfessional();
                            }}
                            loading={registerReducer}
                          >
                            <FormattedMessage id="Done" />
                          </ReusableButton>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </>
              ) : (
                <Row className="flex justify-end pt-48 sm:pt-32">
                  <Col
                    xs={12}
                    sm={4}
                    md={2}
                    lg={2}
                    xl={2}
                    xxl={2}
                    className="pt-16 sm-pt-0"
                  >
                    <ReusableButton
                      fullWidth={true}
                      variant="outlined"
                      color="#3C3C3C"
                      fontSize="16px"
                      fontWeight="500"
                      padding="14px 55px"
                      height="44px"
                      bgColor="transparent"
                      brColor="#EFE3D7"
                      fontFamily="outfit_medium"
                    >
                      <FormattedMessage id="Cancel" />
                    </ReusableButton>
                  </Col>
                  <Col
                    xs={12}
                    sm={4}
                    md={2}
                    lg={2}
                    xl={2}
                    xxl={2}
                    className="pt-16 sm-pt-0"
                  >
                    <ReusableButton
                      fullWidth={true}
                      variant="outlined"
                      color="#F5F5F5"
                      fontSize="18px"
                      fontWeight="600"
                      padding="12px 50px"
                      height="44px"
                      bgColor="#375241"
                      brColor="#375241  "
                      fontFamily="outfit_semiBold"
                      disabled={
                        subListPrev && subListPrev?.length === 0 && 'true'
                      }
                      onClick={() =>
                        subListPrev &&
                        subListPrev?.length > 0 &&
                        handleProfessional()
                      }
                    >
                      <FormattedMessage id="Done" />
                    </ReusableButton>
                  </Col>
                </Row>
              )}
            </div>
          </Col>
        </Row>
      </Row>

      <CommonModal
        padding={'32px'}
        width={'736px'}
        modalActive={isProfessionalModal}
        innerContent={
          <div>
            <div className="fs-20 family_outfit_semiBold_600 lh-252 fc-292D32">
              Select a Practice
            </div>
            <Row>
              <Col xs={12}>
                <div className="pt-24">
                  <p className="p-0 m-0 fs-14 lh-176 fc-292D32 family_outfit_medium_500">
                    Practice Name
                  </p>
                  <SelectInput
                    placeholder={intl.formatMessage({
                      id: 'Practice Name',
                    })}
                    name={'practiceName'}
                    value={formData?.practice_name}
                    data={providerData}
                    onChange={(e) => handleChange(e, 'practiceName')}
                    disabled={providerValue === formData?.practice_name}
                  />
                </div>
              </Col>
            </Row>
            <div className="fs-16 family_outfit_medium_500 lh-201 fc-292D32 pt-24">
              Select sub-practices
            </div>
            <div className="flex flex-wrap">
              {formData?.sub_practice_info &&
                formData?.sub_practice_info?.length > 0 &&
                formData?.sub_practice_info.map((item, index) => {
                  return (
                    <div
                      className="practice-box ml-2"
                      onClick={() => handleSelectPractice(item)}
                      style={{
                        border: subListId.includes(item?.id)
                          ? '1px solid #864629'
                          : '1px solid #EFE3D7',
                        background: subListId.includes(item?.id) && '#FEF9F6',
                      }}
                    >
                      <div
                        className="fs-14 family_outfit_regular_400 lh-176"
                        style={{
                          color: subListId.includes(item?.id)
                            ? '#864629 '
                            : '#3C3C3C',
                        }}
                      >
                        {item?.name}
                      </div>
                    </div>
                  );
                })}
            </div>
            <Row className="flex justify-end pt-24 mt-190 sm:mt-0">
              <Col md={3}>
                <Button
                  variant="contained"
                  className="button-register"
                  onClick={() => handleCloseModal()}
                >
                  Cancel
                </Button>
              </Col>
              <Col md={3} className="pt-16 md:pt-0">
                <Button
                  variant="contained"
                  className={
                    subListPrev && subListPrev?.length > 0
                      ? 'button'
                      : 'button-disabled'
                  }
                  onClick={() => handleSelectList()}
                  disabled={subListPrev && subListPrev?.length === 0 && 'true'}
                >
                  Next
                </Button>
              </Col>
            </Row>
          </div>
        }
      />
    </>
  );
};

export default RegisterProfessionalDetail;
